export const errors = {
  REQUIRED_FIELD: 'שדה חובה',
  PASSWORDS_DONT_MATCH: 'סיסמה לא תואמת',
  INVALID_EMAIL: 'כתובת אימייל לא תקינה',
  EMAIL_IS_NOT_ALLOWED: 'כתובת המייל לא מאושרת לרישום',
  SERVER_ERROR: 'אירעה תקלה כללית, אנא נסו שנית או פנו לתמיכה',
  FILL_BLOCK_AND_PLOT: 'אנא מלאו גוש חלקה ותת חלקה',
  FILL_ADDRESS: 'אנא מלאו כתובת מלאה',
  WRONG_ADDRESS: 'לא נמצאה מפה, אנא בידקו את הכתובת או נסו לאתר ידנית',
  MUST_APPROVE_EMAIL: 'לפני הכניסה, אנא ודאו שאישרתם את הרישום במייל שנשלח אליכם',
  INTERNAL_SERVER_ERROR: 'אירעה תקלה כללית במערכת, אנא התחברו שוב ונסו שנית',
  CREATE_FINAL_PDF_ERROR: 'יצירת דו"ח נכשלה, אנא נסו שוב או פנו לתמיכה',
  STEPS_NOT_FILLED: 'אנא מלאו קודם את כל שדות החובה בשלבים השונים',
  NOT_ALLOWED: 'אין לכם הרשאה לצפות בעמוד זה',
  FILE_NOT_FOUND: 'הקובץ לא נמצא',
  FILE_ALREADY_EXISTS: 'קובץ בשם זה כבר קיים בדוח זה, אנא שנו את השם ונסו שנית'
};

export const cognitoErrors = {
  NotAuthorizedException: 'שם משתמש ו\\או סיסמה שגויים',
  UsernameExistsException: 'משתמש עם כתובת מייל זו כבר קיים במערכת',
  InvalidPasswordException: 'סיסמה לא עומדת בדרישות אבטחה',
  UserNotConfirmedException: 'לפני הכניסה, אנא ודאו שאישרתם את הרישום במייל שנשלח אליכם',
  InvalidParameterException: 'סיסמה לא עומדת בדרישות אבטחה'
};
